import React from 'react';
import { Global, css } from '@emotion/core';
import {
    neutral50,
    neutral100,
    neutral200,
    neutral300,
    neutral400,
    neutral500,
    neutral900
} from '@fever/ui';

function GlobalCss({ titleColor = neutral900 }) {
    return (
        <Global
            styles={css`
                /* 定義全域 CSS 變數：Froala 編輯器的預設文字顏色 */
                :root {
                    --froala-text-color: ${titleColor};
                }
                
                body {
                    font-family: var(--fw-font-sans);
                    margin: 0;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                }

                html,
                body {
                    height: 100%;
                    width: 100%;
                }

                #root {
                    height: 100%;
                    width: 100%;
                }

                * {
                    box-sizing: border-box;
                }

                // scrollbar custom css
                .ScrollbarsCustom-Track {
                    background: ${neutral50} !important;
                    border-radius: 4px !important;
                }

                .ScrollbarsCustom-Thumb {
                    background: ${neutral300} !important;
                    border-radius: 4px !important;
                    &:hover {
                        background: ${neutral500} !important;
                    }
                }
                
                /* 強制覆蓋 Froala 內建的黑色 (支援 v2 和 v4) */
                .fr-box.fr-basic .fr-element,
                .fr-box .fr-element,
                .froala-viewer {
                    color: var(--froala-text-color) !important;
                }
                
                /* 重點：讓所有子元素繼承父層顏色，inline style 會自動覆蓋這個繼承 */
                .fr-element * {
                    color: inherit;
                }
                
                ${muiDisabledStyle}
                ${transitionFadeStyle}
                ${animationGradientBgStyle}
            `}
        />
    );
}

export default GlobalCss;

const muiDisabledStyle = css`
    .MuiButtonBase-root.Mui-disabled,
    .MuiSelect-select.Mui-disabled,
    .MuiInputBase-input.Mui-disabled {
        cursor: not-allowed;
        pointer-events: auto;
        &:active {
            pointer-events: none;
        }
    }
    .MuiButtonBase-root.MuiSwitch-switchBase.Mui-disabled {
        pointer-events: initial;
    }
    .MuiButtonBase-root,
    .MuiTypography-button {
        text-transform: initial;
    }
`;

const transitionFadeStyle = css`
    .fever-fade-next-enter {
        opacity: 0;
        transform: translateX(5%);
    }
    .fever-fade-next-enter-active {
        opacity: 1;
        transform: translateX(0%);
    }
    .fever-fade-next-exit {
        opacity: 1;
        transform: translateX(0%);
    }
    .fever-fade-next-exit-active {
        display: none;
    }
    .fever-fade-next-enter-active {
        transition: all 200ms ease-in-out;
    }

    .fever-fade-prev-enter {
        opacity: 0;
        transform: translateX(-5%);
    }
    .fever-fade-prev-enter-active {
        opacity: 1;
        transform: translateX(0%);
    }
    .fever-fade-prev-exit {
        opacity: 1;
        transform: translateX(0%);
    }
    .fever-fade-prev-exit-active {
        display: none;
    }
    .fever-fade-prev-enter-active {
        transition: all 200ms ease-in-out;
    }
`;

export const animationGradientBgStyle = css`
    .fever-anim-gradient-bg {
        background: linear-gradient(
            -45deg,
            ${neutral100},
            ${neutral400},
            ${neutral200},
            ${neutral500}
        );
        background-size: 400% 400%;
        animation: fever-gradient-bg 15s ease infinite;
    }

    @keyframes fever-gradient-bg {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }
`;
